export default {
  underclassSampleImgUrl: '/assets/img/UC-SampleStudent-2.png',
  underclassImagePromptPlaceholder:
    'cady-uc-media://selected?subjectId={SubjectId}&background={OrderDefaultBackgroundColor}',
  underclassBackgroundData: [
    {
      id: 'UC_grey',
      imageUrl: '/assets/img/underclass-pose-backgrounds/UC_grey.jpg'
    },
    {
      id: 'UC_blue',
      imageUrl: '/assets/img/underclass-pose-backgrounds/UC_blue.jpg'
    },
    {
      id: 'UC_green',
      imageUrl: '/assets/img/underclass-pose-backgrounds/UC_green.jpg'
    },
    {
      id: 'UC_brown',
      imageUrl: '/assets/img/underclass-pose-backgrounds/UC_brown.jpg'
    },
    {
      id: 'UC_pink',
      imageUrl: '/assets/img/underclass-pose-backgrounds/UC_pink.jpg'
    },
    {
      id: 'UC_red',
      imageUrl: '/assets/img/underclass-pose-backgrounds/UC_red.jpg'
    },
    {
      id: 'UC_modblue',
      imageUrl: '/assets/img/underclass-pose-backgrounds/UC_modblue.jpg'
    },
    {
      id: 'UC_modgrey',
      imageUrl: '/assets/img/underclass-pose-backgrounds/UC_modgrey.jpg'
    },
    {
      id: 'UC_teal',
      imageUrl: '/assets/img/underclass-pose-backgrounds/UC_teal.jpg'
    }
  ]
}

// TODO these need to be replaced with a way to ID an item that isn't editable by Sunny16 admin users
export const retouchingBundleConstants = {
  SINGLE_IMAGE_RETOUCHING_IDENTIFIER: 'RETOUCH_ADV_SINGLE',
  ALL_IMAGES_RETOUCHING_IDENTIFIER: 'RETOUCH_ADV_ALL',
  RETOUCHING_INCLUDE_MEDIA_TAG: 'retouching-include'
}

// TODO these need to be replaced with a way to ID an item that isn't editable by Sunny16 admin users
export const downloadAllBundleConstants = {
  DOWNLOAD_ALL_ITEM_IDENTIFIER: 'DIGITAL_ALL'
}
